// Module 11 — Dispatch assignment lifecycle constants (frontend mirror of migration 027 constraints).
// The database is the source of truth. These constants decide what the UI offers — the DB re-checks.

// Main lifecycle path for an accepted assignment, in order.
export const ASSIGNMENT_LIFECYCLE = [
    'offered',
    'accepted',
    'en_route',
    'on_location',
    'passenger_onboard',
    'completed',
];

// Side-exits that can occur before or after acceptance.
export const ASSIGNMENT_SIDE_EXITS = ['declined', 'timed_out', 'reassigned'];

// All valid assignment statuses (must match migration 027 CHECK constraint).
export const ASSIGNMENT_STATUSES = [...ASSIGNMENT_LIFECYCLE, ...ASSIGNMENT_SIDE_EXITS];

// Human-friendly labels + pill styling for every assignment status.
export const ASSIGNMENT_STATUS_META = {
    offered:           { label: 'Offered',           icon: '📤', pill: 'bg-blue-100 text-blue-800 border-blue-300' },
    accepted:          { label: 'Accepted',          icon: '✅', pill: 'bg-green-100 text-green-800 border-green-300' },
    en_route:          { label: 'En Route',          icon: '🚗', pill: 'bg-amber-100 text-amber-800 border-amber-300' },
    on_location:       { label: 'Arrived Onsite', icon: '📍', pill: 'bg-orange-100 text-orange-800 border-orange-300' },
    passenger_onboard: { label: 'Passenger Onboard', icon: '🧑', pill: 'bg-purple-100 text-purple-800 border-purple-300' },
    completed:         { label: 'Completed',         icon: '🏁', pill: 'bg-teal-100 text-teal-800 border-teal-300' },
    declined:          { label: 'Declined',          icon: '🚫', pill: 'bg-red-100 text-red-800 border-red-300' },
    timed_out:         { label: 'Timed Out',         icon: '⏱️', pill: 'bg-rose-100 text-rose-800 border-rose-300' },
    reassigned:        { label: 'Reassigned',        icon: '🔄', pill: 'bg-slate-100 text-slate-700 border-slate-300' },
};

// Dispatch Waterfall phase labels — displayed to help the dispatcher know where they are.
export const WATERFALL_PHASES = [
    { key: 'preferred',   label: 'Preferred Drivers',     icon: '⭐' },
    { key: 'general',     label: 'General Roster',         icon: '👥' },
    { key: 'checkpoint',  label: 'Dispatch Checkpoint',    icon: '🛑' },
    { key: 'affiliate',   label: 'Affiliate / Override',   icon: '🤝' },
];

export function assignmentStatusMeta(status) {
    return ASSIGNMENT_STATUS_META[status] || { label: status || '—', icon: '•', pill: 'bg-gray-100 text-gray-700 border-gray-300' };
}

export function isSideExit(status) {
    return ASSIGNMENT_SIDE_EXITS.includes(status);
}

export function isTerminal(status) {
    return ['completed', 'declined', 'timed_out'].includes(status);
}
